<template>
  <div
    class="btn-group btn-group-lg"
    role="group"
    aria-label="Basic radio toggle button group"
  >
    <template v-for="filter in filters" :key="filter.id">
      <input
        type="radio"
        class="btn-check"
        :name="groupName"
        :id="filter.id"
        autocomplete="off"
        :value="filter.id"
        v-model="selectedFilter"
      />
      <label class="btn btn-outline-dark" :for="filter.id">{{
        filter.label
      }}</label>
    </template>
  </div>
</template>

<script>
/* https://vuejs.org/guide/essentials/lifecycle.html#lifecycle-diagram */

export default {
  name: "ButtonGroupComponent",
  components: {},
  data() {
    return {
      selectedFilter: ""
    };
  },
  emits: ["setSelectedFilter"],
  props: {
    filters: {
      type: Array,
      required: true
    },
    groupName: {
      type: String,
      required: true
    }
  },
  computed: {},
  methods: {},
  mounted() {
    // Set the first filter as selected by default
    this.selectedFilter = this.filters[0].id;
  },
  watch: {
    // Watch for changes in selectedFilter and emit the new value
    selectedFilter(newFilter) {
      this.$emit("setSelectedFilter", newFilter);
    }
  }
  /* lifecycle hooks */
};
</script>
